module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_250_500.ea033f3b.png";